import { SharedState } from 'app/types-shared';

export const getExternalUrlAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.externalUrl?.administrationCentral;
